import r from "./eq.js";
function o(t, n) {
  for (var e = t.length; e--; )
    if (r(t[e][0], n))
      return e;
  return -1;
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_assocIndexOf.js
// module id = 296
// module chunks = 41